module.exports = __webpack_public_path__ + "static/media/adviceIcon.6f5cdec1.svg";